<template>
  <div class="borrowell">
    <p class="borrowell__text">
      Knowing your credit score is an important step to improving your financial wellbeing.
    </p>

    <p class="borrowell__text">
      While you wait we recommend visiting our friends below to get your free credit report.
    </p>

    <div
      v-data-layer
      :data-layer="datalayer"
      class="app-button-link"
    >
      <a
        :href="link"
        target="_blank"
        rel="nofollow"
      >
        <AppButton>Get Your Free Credit Score</AppButton>
      </a>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButtonContinue'
import StepTooltip from '@/components/common/step/StepTooltip'
export default {
  // Name
  name: 'borrowell-banner',

  // Components
  components: {
    AppButton,
    StepTooltip
  },

  // Props
  props: {
    title: {
      type: String,
      default: 'Give Your Credit a\n Jump Start!'
    },
    link: {
      required: true,
      type: String
    },
    datalayer: {
      required: true,
      type: String,
      default: 'finished_capone_apply'
    }
  }
}
</script>

<style scoped lang="scss">
.borrowell {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &__text {
    font-size: 14px;
    line-height: 1.6;
    color: #363636;

    @include breakpoint('tablet-portrait-up') {
      font-size: 20px;
      max-width: 500px;
    }
  }

  .app-button-link {
    width: 100%;
    margin: 15px 0;

    @include breakpoint('tablet-portrait-up') {
      margin: 30px 0 0 0;
    }

    @include breakpoint('tablet-landscape-up') {
      width: 380px;
    }
  }
}
</style>
